export enum ActionScope {
    /**
     * 指派
     */
    AssignUser = 'AssignUser',
    /**
     * 移交
     */
    Transfer = 'Transfer',
    /**
     * 征询
     */
    AddSignFront = 'AddSignFront',
    /**
     * 加签
     */
    AddSignBehind = 'AddSignBehind',
    /**
     * 知会
     */
    Notify = 'Notify',
}